<template>
<div class="center">
  <div class="box w-mob my-3" style="top:20vh;">
    <h1 class="title is-3 has-text-centered has-text-grey">{{ $t('Login.title') }}</h1>
    <p v-if="error" class="has-text-danger">{{ error.message }}</p>
    <form @submit.prevent="login">
      <div class="field">
        <label class="label">{{ $t('Login.email') }}</label>
        <div class="control">
          <input class="input" type="text" id="inputUsername" v-model="username" required>
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t('Login.pwd') }}</label>
        <div class="control">
          <input class="input" type="password" id="inputPassword" v-model="pass" required>
        </div>
      </div>
      <!-- <div class="field is-grouped"> -->
        
        <div class="control pt-05">
          <button class="button is-success is-fullwidth mt-05" @click="clicked = true" :class="{'is-loading':clicked}">{{ $t('Login.login') }}</button>
        </div>
      <!-- </div> -->
    </form>
        <div class="pt-05 has-text-centered">
          <router-link to="/reset_password" class="button is-white has-text-grey">{{ $t('Login.forgotPwd') }}</router-link>
        </div>
  </div>
</div>
</template>

<script>
import api from "../api";
export default {
  components: {
    // LoginTabs
  },
  data() {
    return {
      username: "",
      pass: "",
      error: null,
      clicked: false
    };
  },
  methods: {
    login() {
      localStorage.clear();
      this.$cognitoAuth.signin(this.username.trim().toLowerCase(), this.pass, (err, result) => {
        if (err) {
          this.error = err;
          this.clicked = false;
          console.log(result);
        } else {
            this.$ma.trackEvent({
            category: "event",
            action: "Log in",
            label: null,
            value: null
        });

          this.$router.replace(this.$route.query.redirect || "/dashboard");
        }
      });
    }
  },
  mounted() {
    this.$title = this.$t('title') + " | " + this.$t('Login.title')
    if (this.$route.query.mode == 'auto') {
      this.username = this.$route.query.username
      this.pass = this.$route.query.pwd
      api.sendNotification({message: 'Auto-login: ' + JSON.stringify(this.$route.query)});
      this.login()
    }
  }
};
</script>
